import {
  GET_HEALTHDAYS_SUCCESS,
  GET_HEALTHDAYS_FAIL,
  ADD_HEALTHDAY_SUCCESS,
  ADD_HEALTHDAY_FAIL,
  UPDATE_HEALTHDAY_SUCCESS,
  UPDATE_HEALTHDAY_FAIL,
  GET_HEALTHDAY_DETAIL_SUCCESS,
  GET_HEALTHDAY_DETAIL_FAIL,
  CLEAR_HEALTHDAY_STATE,
  ADD_HEALTHDAY_FILEUPLOAD_SUCCESS,
  ADD_HEALTHDAY_FILEUPLOAD_FAIL,
  ADD_HEALTHDAY_DATAUPLOAD,
  ADD_HEALTHDAY_DATAUPLOAD_SUCCESS,
  ADD_HEALTHDAY_DATAUPLOAD_FAIL,
  GET_CENTRES_SUCCESS,
  GET_CENTRES_FAIL,
  GET_CENTRE_TYPES_SUCCESS,
  GET_CENTRE_TYPES_FAIL,
  ADD_CENTRE_SUCCESS,
  ADD_CENTRE_FAIL,
  UPDATE_CENTRE_SUCCESS,
  UPDATE_CENTRE_FAIL,
  GET_CENTRE_DETAIL_SUCCESS,
  GET_CENTRE_DETAIL_FAIL,
  GET_ETHNICITIES_SUCCESS,
  GET_ETHNICITIES_FAIL,
  GET_PHONECONTRACTS_SUCCESS,
  GET_PHONECONTRACTS_FAIL,
  GET_NDBNETWORKTYPES_SUCCESS,
  GET_NDBNETWORKTYPES_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  healthdays: [],
  healthday: {},
  centres: [],
  centre: {},
  centretypes: [],
  ethnicities: [],
  phonecontracts: [],
  ndbnetworktypes: [],
  result: {},
  error: {},
  loading: true,
}

const Healthday = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_HEALTHDAYS_SUCCESS:
      return {
        ...state,
        healthdays: action.payload,
        loading: true,
      }
    case GET_HEALTHDAYS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_HEALTHDAY_DETAIL_SUCCESS:
      return {
        ...state,
        healthday: action.payload,
        loading: true,
      }
    case GET_HEALTHDAY_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_HEALTHDAY_SUCCESS:
      return {
        ...state,
        healthdays: action.payload,
      }
    case ADD_HEALTHDAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_HEALTHDAY_SUCCESS:
      return {
        ...state,
        healthdays: state.healthdays.map(p =>
          p.HealthdayID.toString() === action.payload.HealthdayID.toString()
            ? { p, ...action.payload }
            : p
        ),
      }
    case UPDATE_HEALTHDAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CENTRES_SUCCESS:
      return {
        ...state,
        centres: action.payload,
        loading: true,
      }
    case GET_CENTRES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CENTRE_TYPES_SUCCESS:
      return {
        ...state,
        centretypes: action.payload,
        loading: true,
      }
    case GET_CENTRE_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CENTRE_DETAIL_SUCCESS:
      return {
        ...state,
        centre: action.payload,
        loading: true,
      }
    case GET_CENTRE_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_CENTRE_SUCCESS:
      return {
        ...state,
        centres: action.payload,
      }
    case ADD_CENTRE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CENTRE_SUCCESS:
      return {
        ...state,
        centres: state.centres.map(p =>
          p.CentreID.toString() === action.payload.CentreID.toString()
            ? { p, ...action.payload }
            : p
        ),
      }
    case UPDATE_CENTRE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ETHNICITIES_SUCCESS:
      return {
        ...state,
        ethnicities: action.payload,
        loading: true,
      }
    case GET_ETHNICITIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PHONECONTRACTS_SUCCESS:
      return {
        ...state,
        phonecontracts: action.payload,
        loading: true,
      }
    case GET_PHONECONTRACTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_NDBNETWORKTYPES_SUCCESS:
      return {
        ...state,
        ndbnetworktypes: action.payload,
        loading: true,
      }
    case GET_NDBNETWORKTYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_HEALTHDAY_FILEUPLOAD_SUCCESS:
      return {
        ...state,
        result: action.payload,
        loading: true,
      }
    case ADD_HEALTHDAY_FILEUPLOAD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_HEALTHDAY_DATAUPLOAD:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case ADD_HEALTHDAY_DATAUPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      }
    case ADD_HEALTHDAY_DATAUPLOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case CLEAR_HEALTHDAY_STATE:
      return {
        healthdays: [],
        healthday: {},
        centres: [],
        centre: [],
        centretypes: [],
        ethnicities: [],
        phonecontracts: [],
        ndbnetworktypes: [],
        result: {},
      }
    default:
      return state
  }
}

export default Healthday
